import { useNavigate } from 'react-router-dom';
import { images } from '../../constants/images';
import styles from './navBar.module.scss';

const NavBar = () => {
    const navigate = useNavigate();

    const navOptions = [
        {
            id: "help",
            label: "Ayuda",
            icon: images.linzeWhatsIcon,
            href: "https://wa.me/56983741923?text=Hola%21+Quiero+cotizar+mi+Citroen"
        }
    ]

    return (
        <header>
            <img onClick={() => navigate("/")} src={images.citroenHeaderIcon} className={styles.citroenHeaderIcon} />
            <div className={styles.navOptions}>
                {
                    navOptions.map((option) => (
                        <a href={option.href} target="_blank" className={styles.navOption}>
                            <img src={option.icon} alt={option.label} />
                            <span>{option.label}</span>
                        </a>
                    ))
                }
            </div>
        </header>
    )
}

export default NavBar;